import { render, staticRenderFns } from "./AccountsViewList.vue?vue&type=template&id=56b11c79"
import script from "./AccountsViewList.vue?vue&type=script&lang=js"
export * from "./AccountsViewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports